import React, { useContext } from 'react';
import '../../../stylesheets/stylesLayout/tableViews.scss';
import { ContextAri, ProviderAri } from '../../contextsProperty/ContextAri';
import MessageBar from './MessageBar';
import IconButton from '@mui/material/IconButton';
import Icon from './Icon';
import WithTooltip from './WithTooltip';
import { Typography } from '@mui/material';
import AriTableView from './view/AriTableView';
// import AriCalendarView from './view/AriCalendarView';
import { ProviderAriCalendar } from '../../contextsProperty/ContextCalendarAri';
import useTranslate from '../../../customHooks/useTranslate';

const AriPage = () => {
    const { isOpenedFiltersBar, toggleFiltersBar } = useContext(ContextAri);

    // const [view, setView] = useState('table');

    const translate = useTranslate();

    const filtersBarIconName = isOpenedFiltersBar
        ? 'FilterAltOff'
        : 'FilterAlt';

    const tooltip = translate(
        isOpenedFiltersBar ? 'hide_filters' : 'show_filters'
    );

    // const handleToggleView = () => {
    //     setView(view === 'table' ? 'calendar' : 'table');
    // };

    // const isAdminUser = IdHotelOwner === '8088';

    // const txtCalendar = translate('calendar_view');
    // const txtTable = translate('table_view');

    return (
        <div className='ari-page'>
            <MessageBar />
            <div className='flex flex-between align-items-center margin-bottom-4'>
                <div className='flex flex-align-baseline'>
                    <Typography variant='h1'>Ari</Typography>
                </div>
                <div>
                    <WithTooltip title={tooltip}>
                        <IconButton size='small' onClick={toggleFiltersBar}>
                            <Icon iconName={filtersBarIconName} />
                        </IconButton>
                    </WithTooltip>
                </div>
            </div>
            {/* {view === 'table' ?  */}
            <AriTableView />
            {/* : <AriCalendarView /> */}
            {/* {isAdminUser && ( */}
            {/* <WithTooltip title={view === 'table' ? txtCalendar : txtTable}> */}
            {/*     <IconButton size='small' onClick={handleToggleView}>
            //         <Icon
            //             iconName={
            //                 view === 'table' ? 'TableView' : 'CalendarViewMonth'
            //             }
            //         />
            //         <Typography variant='body2' style={{ marginLeft: '8px' }}>
            //             {view === 'table' ? txtCalendar : txtTable}
            //         </Typography>
            //     </IconButton>
            // </WithTooltip>
            {/* )} */}
        </div>
    );
};

const AriPageWithProvider = () => (
    <ProviderAri>
        <ProviderAriCalendar>
            <AriPage />
        </ProviderAriCalendar>
    </ProviderAri>
);

export default React.memo(AriPageWithProvider);
